var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58971 13.25C1.16874 13.25 0.812419 13.1042 0.520752 12.8125C0.229085 12.5208 0.083252 12.1645 0.083252 11.7435V2.25646C0.083252 1.83549 0.229085 1.47917 0.520752 1.1875C0.812419 0.895833 1.16874 0.75 1.58971 0.75H14.4101C14.8311 0.75 15.1874 0.895833 15.4791 1.1875C15.7708 1.47917 15.9166 1.83549 15.9166 2.25646V11.7435C15.9166 12.1645 15.7708 12.5208 15.4791 12.8125C15.1874 13.1042 14.8311 13.25 14.4101 13.25H1.58971ZM1.58971 12H10.2916V8.92313H1.33325V11.7435C1.33325 11.8077 1.35999 11.8665 1.41346 11.9198C1.46679 11.9733 1.52554 12 1.58971 12ZM11.5416 12H14.4101C14.4743 12 14.533 11.9733 14.5864 11.9198C14.6398 11.8665 14.6666 11.8077 14.6666 11.7435V4.59625H11.5416V12ZM1.33325 7.67313H10.2916V4.59625H1.33325V7.67313Z",
    fill: "#90A4B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutIcon);
export default __webpack_public_path__ + "static/media/layout-icon.db718195546f11d8a87acb84ccf7d4de.svg";
export { ForwardRef as ReactComponent };